module.exports = __webpack_public_path__ + "static/media/ins21.a6ab266a.jpg";